<template>
  <section class="section-base form-section-base">
    <v-container>
      <div class="form-base">
        <MrpaUploader
          :v="v"
          :statement-type="StatementType.ACCEPTANCE_ESCROW"
          @parsed-mrpa-change="$emit(AppEvent.PARSED_MRPA_CHANGE, $event)"
        />

        <template v-if="v.formVisible.$model">
          <div class="form-section-base__title">
            Сведения о доверенности в машиночитаемом виде
          </div>

          <div class="form-section-base__controls">
            <v-row>
              <v-col>
                <v-radio-group v-model="v.role.$model" row disabled>
                  <v-radio label="Физическое лицо" :value="Role.PERSON" />
                  <v-radio
                    label="Юридическое лицо"
                    :value="Role.ORGANIZATION"
                  />
                  <v-radio
                    label="Иностранное юридическое лицо"
                    :value="Role.FOREIGN_ORGANIZATION"
                  />
                </v-radio-group>
              </v-col>
            </v-row>
          </div>

          <Person v-if="v.role.$model === Role.PERSON" :v="v.person" />

          <Organization
            v-if="v.role.$model === Role.ORGANIZATION"
            :v="v.organization"
          />

          <ForeignOrganization
            v-if="v.role.$model === Role.FOREIGN_ORGANIZATION"
            :v="v.foreignOrganization"
          />
        </template>
      </div>
    </v-container>
  </section>
</template>

<script>
import { Role } from '@/utils/dictionaries';
import MrpaUploader, {
  mrpaUploaderModel,
  mrpaUploaderValidation,
} from '@/components/services/elements/MrpaUploader';
import Person, { personModel, getPersonValidation } from './Person';
import Organization, {
  organizationModel,
  getOrganizationValidation,
} from './Organization';
import ForeignOrganization, {
  foreignOrganizationModel,
  getForeignOrganizationValidation,
} from './ForeignOrganization';
import { StatementType } from '@/types/services';
import { AppEvent } from '@/constants';

export const machineModel = {
  mrpa: mrpaUploaderModel.mrpa,
  formVisible: mrpaUploaderModel.formVisible,
  role: Role.FOREIGN_ORGANIZATION,
  person: personModel,
  organization: organizationModel,
  foreignOrganization: foreignOrganizationModel,
};

export const getMachineValidation = (machine) => {
  const base = {
    ...mrpaUploaderValidation,
    role: {},
  };

  if (machine.role === Role.PERSON) {
    return {
      ...base,
      person: getPersonValidation(machine.person),
    };
  }

  if (machine.role === Role.ORGANIZATION) {
    return {
      ...base,
      organization: getOrganizationValidation(machine.organization),
    };
  }

  return {
    ...base,
    foreignOrganization: getForeignOrganizationValidation(
      machine.foreignOrganization
    ),
  };
};

export default {
  name: 'Machine',
  props: {
    v: {
      type: Object,
      required: true,
    },
  },
  components: {
    Person,
    Organization,
    ForeignOrganization,
    MrpaUploader,
  },
  data: () => ({
    Role,
    AppEvent,
    StatementType,
  }),
};
</script>
